import { Loader2 } from "lucide-react";

import { AppLogo } from "@/components/shared/app-logo";
import { Skeleton } from "@/components/ui/skeleton";
import { TableCell, TableRow } from "@/components/ui/table";

/**
 * Loading convention for the control-plane console:
 * - TableSkeleton: skeleton rows for data tables (use inside <TableBody>).
 * - PageLoading: centered branded full-page loader for route/page transitions.
 * - Inline action loading stays a bare <Loader2 className="size-3.5 animate-spin" />.
 */

type TableSkeletonProps = {
  rows?: number;
  cols?: number;
};

export function TableSkeleton({ rows = 5, cols = 4 }: TableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: cols }).map((_, colIndex) => (
            <TableCell key={colIndex}>
              <Skeleton className="h-4 w-full" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

type PageLoadingProps = {
  label?: string;
};

export function PageLoading({ label = "Loading…" }: PageLoadingProps) {
  return (
    <div
      role="status"
      aria-label={label}
      className="flex min-h-[240px] w-full flex-col items-center justify-center gap-4 py-12 text-center"
    >
      <AppLogo />
      <div className="text-muted-foreground flex items-center gap-2 text-[13px]">
        <Loader2 className="size-4 animate-spin" aria-hidden="true" />
        {label}
      </div>
    </div>
  );
}
